import React from 'react';
import { Carousel } from './Carousel/Carousel';
import Hero from './Hero/Hero';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Carousel />
    </>
  )
}

export default HomePage